import React, {useState, useEffect, useRef, useContext} from 'react'
import axios from 'axios';
import {FaRegUser} from 'react-icons/fa';
import { IoIosArrowForward, IoIosArrowBack, IoIosArrowDown, IoMdClose} from "react-icons/io";
import {MdAddShoppingCart} from "react-icons/md";
import { RxDoubleArrowLeft, RxDoubleArrowRight } from "react-icons/rx";
import {toast} from 'sonner'; 


import { Link, useSearchParams } from 'react-router-dom';
import { API_URL } from '../App';
import { AuthContext, CartContext } from '../ContextStore';
import { AiOutlineLoading3Quarters } from "react-icons/ai";

import ReactGA from 'react-ga4'
import { useLocation } from 'react-router-dom';
 
export const capitalizeTitle = (string) =>{
  return string.split(' ').map(word=>{
    if(word.charAt(0) === word.charAt(0).toUpperCase() && word.charAt(1) === word.charAt(1).toUpperCase()){
      return word
    } else return word.charAt(0).toUpperCase()+ word.slice(1)
  }).join(' ')
 }
 

const Products = () => {

  const {currentUser} = useContext(AuthContext)
  
  const location = useLocation()
  const activeCategory = location.state?.activeCategory || "";
  const tagHeading = location.state?.tagHeading || ""; 
  const categoryTags = location.state?.tags || ""; 

  const [ searchParams, setSearchParams] = useSearchParams()
const urlSearchQuery = searchParams.get('search') || ''; 

  const [currentStore, setCurrentStore] = useState(null); 
  const [displayCategory, setDisplayCategory]= useState(activeCategory);
  const [searchQuery, setSearchQuery] = useState(urlSearchQuery)
  const [appliedSearchQuery, setAppliedSearchQuery] = useState(urlSearchQuery)

  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20)


  useEffect(() => {
  ReactGA.send({
    hitType: "pageview",
    page: "/products",
    title: "Store"
  });
}, []); 


  useEffect(() => {
    if (urlSearchQuery){
      setDisplayCategory('')
      setSearchQuery(urlSearchQuery)
      setAppliedSearchQuery(urlSearchQuery)
    } else if (location.state?.activeCategory !== undefined) {
    setDisplayCategory(location.state.activeCategory);
  }
  setCurrentPage(1); 
}, [urlSearchQuery, location.state?.activeCategory]);

  useEffect (()=>{ 
      loadProducts(); 
      window.scrollTo(0,0)
    }, [currentPage, displayCategory, appliedSearchQuery])

    const loadProducts = async()=>{
      setLoading(true)
      try{
        const ecodedQuery = encodeURIComponent(appliedSearchQuery)
        const fetchStore = await axios.get(`${API_URL}/store?page=${currentPage}&searchquery=${ecodedQuery}&category=${displayCategory}&tags=${categoryTags}`)

        if(fetchStore?.data?.[0]){ 
          
          const TotalPages = Math.ceil(fetchStore.data[0].totalCount[0].count/rowsPerPage)
          setTotalPages(TotalPages)
          setCurrentStore(fetchStore.data[0].totalData || [])
          
        }else {
          setCurrentStore([])
          setTotalPages(1)
        }
      } catch(err){
        console.log(err)
        setCurrentStore([])
      }finally{
        setLoading(false)
      }
    }

    const changeCategory = (category)=>{
    setDisplayCategory(category)
    setCurrentPage(1)
    }

     const onSearch =  (e)=>{
        if (e) e.preventDefault()
        const trimmedQuery = searchQuery.trim()

        setDisplayCategory('')
        setAppliedSearchQuery(trimmedQuery)  
           setCurrentPage(1)

           if (trimmedQuery) {
            setSearchParams({search: trimmedQuery})
           } else {
            setSearchParams({})
           }

     }

     const handleClearSearch = () =>{
      setSearchQuery('')
      setAppliedSearchQuery('')
      setCurrentPage(1)
      setSearchParams({})
     }

     const getHeadingTitle = ()=>{
      if(appliedSearchQuery) return `Search Results`
      if (displayCategory) return displayCategory;
      if (tagHeading) return tagHeading; 
      return 'Goldyvhista'; 
     }
    

  return (
    <div className=' bg-[#e5e5e5] bg-zinc-100 scroll-smooth' >
      {/*ADMIN SECTION*/}
        { currentUser? ( currentUser.type==='admin'?(
        <div className='flex items-right justify-right bg-white py-2.5 pt-4 px-5 pl-8'> 
        
          <FaRegUser className='m-2 text-tertiary'/>  <p className='mr-5 p-1 text-tertiary '>  {currentUser.email}</p>
        <Link 
             to='/NewProduct' 
              title="" 
              className="mx-1 px-3 py-2 text-sm font-medium text-white focus:outline-none bg-tertiary rounded-lg border border-gray-200 hover:bg-white hover:border-tertiary hover:text-tertiary focus:z-10 focus:ring-4 focus:ring-gray-100 "
              role="button" 
            > 
                New 
      </Link>
          </div>):('')):('')}

      <h1 className='pt-8 pb-2 md:pb-10 font-Elm-sans md:ml-10 text-2xl md:text-5xl text-center text-tertiary'> {getHeadingTitle()}</h1>

      {
         (searchQuery && appliedSearchQuery && currentStore?.length > 0 )&& (
          <p className='text-center p-3 text-gray-500'>{`Search results for "${searchQuery}" `}</p>
         )
      }

          {/*HEADING AND CONTENT SECTION*/}
        <div className='w-full px-2 grid grid-cols-5 md:flex-row md:justify-center '>

              <div className=' flex flex-col w-full col-span-5 md:col-span-1 md:pt-3'>
                 <SearchFunctionality 
                    setSearchQuery={setSearchQuery} 
                    onSearch={onSearch} 
                    searchQuery={searchQuery}
                    handleClearSearch={handleClearSearch}
                    appliedSearchQuery={appliedSearchQuery}
                     />
                <Menu changeCategory={changeCategory} handleClearSearch={handleClearSearch}/>
              </div>
              <hr key="2" className=' col-span-5 h-px mt-2 bg-gray-400 border-0 md:hidden'/>
                
                {/*/products area*/}
                <div className=' gap-1 md:gap-2 grid grid-cols-2 md:grid-cols-4 col-span-5 md:col-span-3 '>
                      <ProductsArea currentStore={currentStore} loading={loading} appliedSearchQuery={appliedSearchQuery}/>
                </div>
        </div>

{/*PAGINATION HERE */}
                <div className='p-3 my-5 mr-3 relative'>
                <nav className=" absolute bottom-0 right-0 inline-flex items-center p-1 rounded bg-gray space-x-2" >
                  <span onClick={()=> setCurrentPage(1)} className="p-1 rounded border cursor-pointer text-tertiary bg-white hover:text-white hover:bg-tertiary hover:border-black">
                    <RxDoubleArrowLeft/>
                  </span>
                  <span onClick={() => setCurrentPage(currentPage => Math.max(currentPage - 1, 1))} disabled={currentPage === 1} className="p-1 rounded border text-tertiary bg-white hover:text-white cursor-pointer hover:bg-tertiary hover:border-white" >
                  <IoIosArrowBack />
                  </span>
                  <span className="text-tertiary">{` Page ${currentPage} of ${totalPages} `}</span>
                  <span onClick={() => setCurrentPage(currentPage => Math.min(currentPage + 1, totalPages))} disabled={currentPage === totalPages} className="p-1 rounded border cursor-pointer text-tertiary bg-white hover:text-white hover:bg-tertiary hover:border-black">
                  <IoIosArrowForward />
                  </span>
                  <span onClick={()=> setCurrentPage(totalPages)} className="p-1 rounded border cursor-pointer text-tertiary bg-white hover:text-white hover:bg-tertiary hover:border-black">
                  <RxDoubleArrowRight/>
                  </span>
                </nav>
                </div>
             
    </div>
    
  )
}


export const SearchFunctionality = (props)=>{

  const {searchQuery, setSearchQuery, onSearch, appliedSearchQuery,handleClearSearch } = props; 

  return (
    <form onSubmit = {onSearch} className='mx-2 mt-1 py-2 flex flex-row  md:mr-10 md:pr-10 w-full'>
    <div className='relative w-full flex items-center '>
     <input
                      type="text" 
                      className="peer px-2 block h-[30px] w-full text-sm bg-transparent outline outline-1 outline-tertiary focus:placeholder:opacity-100 peer-focus:text-primary "
                      placeholder="Search products..."
                      onChange={e=>setSearchQuery(e.target.value)}
                      value= {searchQuery}
                      /> 

          {
            (searchQuery || appliedSearchQuery )&& (
              <button 
              type="button"
              onClick={handleClearSearch}
              title="Clear search"
              className='absolute right-12 text-gray-400 pr-2  hover:text-gray-600'
              >
                <IoMdClose className='h-4 w-4' /> 

              </button>
            )
          }
          <button 
            className=" h-[32px] relative z-[2] flex items-center  bg-extra border border-black px-4  text-xs hover:bg-opacity-90 focus:outline-none"
            type="submit"> 
            
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className='w-5 h-5 text-white'>
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
              </svg>
            
          </button>
    </div>
    </form>
  )
}

const ProductCard = ({item}) =>{

const{ addToCart}= useContext(CartContext)
const handleAddtoCart = (item) =>{
    addToCart(item)
    toast.success(`1x ${capitalizeTitle(item.name)} has been added to your cart!`)
  }
      return (
        <>
        <div   key={`${item._id}`} className='flex font-Elm-sans flex-col my-3 pb-3 md:pb-5 bg-white border border-gray-300 w-full max-w-180px md:max-w-[250px] h-68 '> 
                 
                   <div className=' w-full relative aspect-[4/5] overflow-hidden bg-slate-100 '> 
                    {item.tags&&item.tags.includes('soldout')&&<span className="absolute top-0 right-0 m-2 bg-red-600 px-2 text-center text-xs font-normal text-white"> Sold Out!</span>} 
                         <Link to={`/products/${item._id}`} className={item.tags&&item.tags.includes('soldout')? 'opacity-25':''} ><img className='h-full w-full object-cover transition-transform duration-500 group-hover:scale-110 hover:opacity-70' src={item.imageUrl} />
                         <span className="absolute top-0 left-0 m-2 bg-red-600 px-2 text-center text-xs font-normal text-white"> {item.popular? "Popular": ""} </span>
                         
                         {/*<span className="absolute top-5 left-0 m-2 rounded-full bg-red-600 px-2 text-center text-xs font-normal text-white"> {item.deal? "Good deal": ""} </span>*/}
                         </Link>
                    </div>


                    <div className='w-full px-2 md:px-3'>
                    <Link to={`/products/${item._id}`}> 
                       <div className='h-12 font-Elm-sans md:py-2 md:mb-3'><span className='text-gray-800 mt-2 md:mt-0 text-sm md:text-base line-clamp-2  md:line-clamp-2 md:py-1 mx-auto'>{capitalizeTitle(item.name)}

                        {item.tags&&item.tags.includes('soldout')&&<span className="  relative left-0 bg-red-600 px-2 text-center text-xs font-normal text-white"> Sold Out!</span>} 
                       </span>
                        
                       </div>
                        </Link>   
                       <div className='flex flex-row justify-between md:px-2'>
                          <div className='flex flex-col'> <span className='text-tertiary font-bold text-sm md:text-base '>₦{Intl.NumberFormat("en-US").format(item.sellingPrice)}     </span><span className='line-through text-xs text-red-500'>{} ₦{item.price}</span></div>
                          <div>
                            <button 
                              onClick= {()=>handleAddtoCart(item)}
                              className='mx-1 px-5 py-2 font-medium text-gray-600 focus:outline-none cursor-pointer rounded-lg border border-gray-400 bg-extra hover:bg-amber-200  focus:z-10 focus:ring-4 focus:ring-gray-100'>
                                <MdAddShoppingCart />
                            </button>
                          </div>
                       </div>

                  {/*}  <p className='hidden text-black text-sm'>Discount: <span className='text-tertiary font-bold md:font-medium'> {item.discount>0? "Yes": "No"}</span> </p>
                    <p className=' hidden text-black text-sm'>Added: <span className='text-gray-500'>{moment(item.date).fromNow()}</span> </p>*/}
                    </div> 

                                      
                  </div>
        </>
      )
     }

const Menu = ({changeCategory, handleClearSearch}) =>{

        const categories = [
          'Babies & Kids',
          'Kitchen Utensils',
          'Home Essentials',
          'Gifts & Souvenirs',
          'Decors',
          'Exercise & Fitness Supplies'
        ]

        const handleSelectCategory = (cat) =>{
          handleClearSearch()
          changeCategory(cat)
        }

      return (
        <>
        <div className='' >               

                <div className='mx-5 dropdown md:hidden md:px-3 py-2 flex flex-row md:pl-10 md:ml-10'>
                    
                  <div tabIndex={0} role="button" className='btn btn-sm btn-outline bg-gray hover:bg-tertiary text-tertiary hover:text-white m-1'>Shop by category <IoIosArrowDown /> </div>
                  <ul tabIndex={0} className='dropdown-content menu bg-tertiary rounded-box z-[1] w-52 p-2 ml-1 shadow'>
                    <li onClick={()=>{
                      handleClearSearch()
                      changeCategory('')  
                      }} className='text-zinc'><span>All Categories</span></li>

                      {categories.map((cat)=>(
                        <li onClick={()=>handleSelectCategory(cat)} className='text-white'><span>{cat}</span></li>
                      )
                      )}

                  </ul>
                </div>
                <div className='hidden md:flex md:w-64 mt-1 p-2'>
                <ul tabIndex={0} className='dropdown-content menu  z-[1] p-2 ml-1 '>
                      <li onClick={()=>{changeCategory('') }} className='text-zinc'><span>All Categories</span></li>
                         {categories.map((cat)=>(
                        <li onClick={()=>handleSelectCategory(cat)} className='text-gray-500'><span>{cat}</span></li>
                      )
                      )}
                    </ul>
                  </div>  
            
          </div>
        </>
      )
     }

const ProductsArea = ({currentStore, loading, appliedSearchQuery}) =>{

  if (loading){
    return(
      <div className='flex justify-center col-span-5 items-center w-full min-h-96'>
          <AiOutlineLoading3Quarters className="animate-spin text-tertiary text-3xl"/>
      </div>
    )
  }

  if(!currentStore || currentStore?.length === 0 ){
    return(
      <div className='col-span-5 text-center py-12 text-gray-500'>
        {appliedSearchQuery ? `No products found matching "${appliedSearchQuery}"`: "No products availabe"}
      </div>
    )
  }
  return (
    <>
    { currentStore ? <>
                        
                          {currentStore.map((item)=>(<>                
                            <ProductCard item={item}/>
                            </>
                          ))}
                          </>        
                          :
                          <div className='flex justify-center col-span-5 align-center items-center w-full h-full min-h-96'>
                        <AiOutlineLoading3Quarters className="loading-icon"/>
                        </div>
                  } 
                  </>
                  )
}

export default Products